import type { User } from "../state/user";
import type { Group } from "../state/group";
import type FormId from "../state/FormId";

export const getUsersWithFormAccess = (users: User[], groups: Group[], formId: FormId): User[] => {
  const groupsWithAccess = getGroupsWithFormAccess(groups, formId);

  return users.filter(
    (user) =>
      user.groups.some((userGroupId) => groupsWithAccess.some(({ id }) => id.equals(userGroupId))) ||
      user.grants.some((grant) => formId.toString() === grant.resourceId.toString()),
  );
};

export const getGroupsWithFormAccess = (groups: Group[], formId: FormId): Group[] =>
  groups.filter((group) => group.grants.some((grant) => formId.toString() === grant.resourceId.toString()));
